import { apiFetch } from '@nrdy-marketing-engine/api-fetch';
import { PriceItem } from '../../../@types/price-item';

const activeEndDateCheck = (price: PriceItem) => new Date(price.ends_at) >= new Date();

const fetchPrices = (itemId: string) =>
  apiFetch<{ data: PriceItem[] }>(`/v1/prices?item_ids=${itemId}`).then(({ data: prices }) => {
    return prices.map((price) => ({
      ...price,
      active: price.ends_at ? activeEndDateCheck(price) : true,
    }));
  });

export default fetchPrices;
